import axios from 'axios';

let isRedirecting = false;

export const setupAxiosInterceptors = (logout: () => void, navigate: (path: string) => void) => {
  // Response interceptor to handle 401 errors
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401 && !isRedirecting) {
        isRedirecting = true;
        
        // Clear auth data
        logout();
        
        // Redirect to login
        navigate('/login');
        
        // Reset flag after a short delay
        setTimeout(() => {
          isRedirecting = false;
        }, 1000);
      }
      
      return Promise.reject(error);
    }
  );
};
